import { getRgObjectsOfType as r, RG_TYPE as t } from "@project-rouge/rg-core";
import { getVerticalWallArea as c } from "./index59.js";
import { isServiceTechSpace as i } from "../../queries/index7.js";
const p = (e) => c(r(e, [t.TechnicalSpace]).filter(i));
export {
  p as getServicesWallArea
};
//# sourceMappingURL=index55.js.map
